import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../contexts/LanguageContext";
import api from "../lib/api";
import { ArrowRight } from "lucide-react";
import useSeo from "../hooks/useSeo";

export default function Services() {
  const { t, lang } = useI18n();
  const [services, setServices] = useState([]);
  useSeo({
    title: "Staffing Services - Recruitment, Payroll, Compliance",
    description: "ENCES Global offers end-to-end workforce solutions: recruitment & onboarding, timekeeping, people operations, payroll, HR compliance, preventive health, replacement staffing and PTO management.",
    path: "/services",
  });
  useEffect(() => { api.get("/services").then((r) => setServices(r.data)).catch(() => {}); }, []);

  return (
    <div data-testid="page-services">
      <section className="bg-navy text-white">
        <div className="container-pad mx-auto max-w-[1400px] py-20">
          <div className="text-xs tracking-[0.3em] uppercase text-white/60 mb-3">{t.services.eyebrow}</div>
          <h1 className="text-4xl md:text-5xl font-extrabold tracking-tight" data-testid="services-title">{t.services_page.title}</h1>
          <p className="mt-4 text-white/70 text-lg max-w-2xl">{t.services_page.subtitle}</p>
        </div>
      </section>

      <section className="container-pad mx-auto max-w-[1400px] py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {services.map((s, i) => (
            <div key={s.key} className="bg-white border border-slate-100 rounded-[24px] p-8 hover:shadow-xl transition-shadow" data-testid={`service-row-${i}`}>
              <div className="flex items-start gap-5">
                <div className="w-12 h-12 rounded-2xl bg-navy text-white flex items-center justify-center text-lg font-extrabold shrink-0">{String(i + 1).padStart(2, "0")}</div>
                <div>
                  <h3 className="text-xl font-bold text-navy">{s[lang]?.name}</h3>
                  <p className="mt-2 text-slate-600 leading-relaxed">{s[lang]?.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-14 rounded-[28px] bg-soft p-10 md:p-12 grid grid-cols-1 md:grid-cols-2 gap-6 items-center">
          <div>
            <h2 className="text-2xl md:text-3xl font-extrabold text-navy">{t.finalCta.title}</h2>
            <p className="mt-2 text-slate-600">{t.finalCta.subtitle}</p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 md:justify-end">
            <Link to="/hire" className="inline-flex items-center justify-center gap-2 px-7 py-4 rounded-full bg-brandred hover:bg-red-700 text-white font-semibold">{t.finalCta.business} <ArrowRight size={16} /></Link>
            <Link to="/contact" className="inline-flex items-center justify-center gap-2 px-7 py-4 rounded-full border-2 border-navy text-navy hover:bg-navy hover:text-white font-semibold transition-colors">{t.nav.contact} <ArrowRight size={16} /></Link>
          </div>
        </div>
      </section>
    </div>
  );
}
